import { ENV, CLIENT } from '../../config';
import { Clients } from '../../utils/clients';

export enum Features {
  Feature0 = 'feature0',
  Feature1 = 'feature1',
  /** @deprecated */
  Uirefresh = 'uirefresh',
  /** @deprecated */
  Plg = 'plg',
  /** @deprecated */
  PlgExternal = 'plgexternal',
  /** @deprecated */
  PlgExternal2 = 'plgexternal2',
  /** @deprecated */
  PlgExternal3 = 'plgexternal3',
  /** @deprecated */
  TrialsOfTiers = 'trialsOfTiers',
  /** @deprecated */
  Plgupgrade = 'plgupgrade',
  /** @deprecated */
  BillingUserFacing = 'billinguserfacing',
  /** @deprecated */
  Templates = 'templates',
  /** @deprecated */
  Panel = 'panel',
  /** @deprecated */
  PlgExternal4 = 'plgexternal4',
  /** @deprecated */
  SectionsPermissions = 'sectionsPermissions',
  /** @deprecated */
  PromotionalCodes = 'promotionalCodes',
  /** @deprecated */
  Branding = 'branding',
  /** @deprecated */
  Communities = 'communities',
  /** @deprecated */
  PlgExternal5 = 'plgexternal5',
  /** @deprecated */
  QlNetquest = 'qlNetquest',
  /** @deprecated */
  DealZero = 'deal_zero',
  /** @deprecated */
  VideoTracking = 'video_tracking',
  /** @deprecated */
  SoftwareAddOnProduct = 'softwareAddOnProduct',
  /** @deprecated */
  ShareableDashboards = 'shareable_dashboards',
  /** @deprecated */
  LeftNavResize = 'left_nav_resize',
  /** @deprecated */
  NewProjectDashboard = 'new_project_dashboard',
  /** @deprecated */
  CreditPoolExtension = 'credit_pool_extension',
   /** @deprecated */
  MainAdminAndAssistantForAll = 'main_admin_assistant_4_all',
   /** @deprecated */
  DeskIntegration = 'desk_integration',
  WorkosSSO = 'workos_sso'
}

export enum Environments {
  Test = 'test', // Only used to test isFeatureEnabled behavior
  Production = 'production',
  Prod = 'prod', // incrowd use prod unlike our deployment which uses production
  Development = 'development',
  Dev = 'dev', // for incrowd
  Staging = 'staging',
}

enum DynamicEnvironments {
  /** @deprecated */
  Uirefresh = 'uirefresh',
  /** @deprecated */
  Plg = 'plg',
  /** @deprecated */
  PlgExternal = 'plgexternal',
  /** @deprecated */
  PlgExternal2 = 'plgexternal2',
  PlgExternal3 = 'plgexternal3',
  /** @deprecated */
  Incrowd = 'incrowd',
  Analytics = 'analytics',
  TiersLite = 'tierslite',
  Tiers = 'tiers',
  Templates = 'templates',
  Netquest = 'netquest',
  PureProfile = 'pureprofile',
  Ada = 'ada',
  Branding = 'branding',
  Dev01 = 'dev01',
  MetaDIY = 'meta-diy',
}

// The concept of a 'feature' is different from the concept of an environment
// A feature can exist even if there's not associated environment
const featureEnablement: Partial<Record<Features, Set<Environments | DynamicEnvironments>>> = {
  [Features.Feature0]: new Set([Environments.Test]),
  [Features.Feature1]: new Set([]),
  [Features.DeskIntegration]: new Set([DynamicEnvironments.Dev01]),
  [Features.WorkosSSO]: new Set([DynamicEnvironments.MetaDIY])
};

// Add feature here to enable it in staging
const featuresDeployedToStaging: Features[] = [];

const featuresDisabledProdByClient: {
  [client: string]: Set<Features>;
} = {
  [Clients.Sightx]: new Set<Features>([Features.CreditPoolExtension]),
  [Clients.Netquest]: new Set<Features>([
    Features.NewProjectDashboard
  ]),
  [Clients.PureProfile]: new Set<Features>([
    Features.NewProjectDashboard,
    Features.CreditPoolExtension
  ]),
  [Clients.Meta]: new Set<Features>([Features.CreditPoolExtension])
};

featuresDeployedToStaging.forEach((feature) => {
  if (!featureEnablement[feature]) {
    featureEnablement[feature] = new Set([]);
  }
  const environments = featureEnablement[feature];
  if (environments) {
    environments.add(Environments.Staging);
  }
});

const featuresDeployedToProd = new Set<Features>([
  Features.Uirefresh,
  Features.Plg,
  Features.PlgExternal,
  Features.PlgExternal2,
  Features.PlgExternal3,
  Features.Plgupgrade,
  Features.Templates,
  Features.TrialsOfTiers,
  Features.BillingUserFacing,
  Features.Panel,
  Features.SectionsPermissions,
  Features.PlgExternal4,
  Features.PromotionalCodes,
  Features.Branding,
  Features.Communities,
  Features.PlgExternal5,
  Features.DealZero,
  Features.QlNetquest,
  Features.VideoTracking,
  Features.SoftwareAddOnProduct,
  Features.ShareableDashboards,
  Features.LeftNavResize,
  Features.NewProjectDashboard,
  Features.CreditPoolExtension,
  Features.MainAdminAndAssistantForAll,
  Features.DeskIntegration
]);

const isDisabledForClientInProd = (feature: Features) => featuresDisabledProdByClient[CLIENT]?.has(feature);

const disableDeployedToProd = (process.env['NODE_ENV'] ?? '') === 'test';
//Since ENV represent any environment it can be safely be treated as the desired type
export const isFeatureEnabled = disableDeployedToProd ?
  (whatFeature: Features) => {
    const environments = featureEnablement[whatFeature];
    return whatFeature === ENV || (environments ? environments.has(ENV as (Environments | DynamicEnvironments)) : false);
  } :
  (whatFeature: Features): boolean => {
    const environments = featureEnablement[whatFeature];
    return (featuresDeployedToProd.has(whatFeature) && !isDisabledForClientInProd(whatFeature)) || (environments ? environments.has(ENV as (Environments | DynamicEnvironments)) : false);
  };
